import React, { Component } from "react";

export default class CompanyBankStatement extends Component {
  constructor(props) {
    super(props);
    this.refs = {
      bankStatementForm: React.createRef(),
    };
    this.state = {};
  }
  saveBankStatement() {
    console.log(
      "saveBankStatement values:",
      this.refs.bankStatementForm.form.current.getData()
    );
  }
  render() {
    return (
      <>
        <AppForm
          className="row mb-2"
          ref="bankStatementForm"
          id="bankStatementForm"
          onSubmit={() => this.saveBankStatement()}
        >
          <AppBankStatement compId={1} editaccess="false" />
          <AppBankStatement compId={2} editaccess="false" />
          <AppBankStatement compId={3} editaccess="false" />
          <div className="row mx-auto align-items-center mt-3">
            <div className="col-12">
              <button
                type="submit"
                className="btn add-btn grey ms-2 text-dark rounded-pill"
              >
                Submit
              </button>
              <button
                type="submit"
                className="btn add-btn btn-warning text-dark rounded-pill"
              >
                Save
              </button>
            </div>
          </div>
        </AppForm>
      </>
    );
  }
}
